const getAuthConfigUrl = (accountId: string) =>
    `${process.env.REACT_APP_TREEZ_AUTH_CONFIG_URL}/${accountId}`;

export const getAuthConfig = async ({
    accessToken,
    accountId,
}: {
    accessToken: string;
    accountId: string;
}) => {
    const response = await fetch(getAuthConfigUrl(accountId), {
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) {
        throw new Error("Failed to fetch auth config");
    }
    return response.json();
};
